import React from "react";

const SortsHeader = () => {
  return <h3 className="font-bold mt-10 text-center">Participant Q sorts</h3>;
};

export default SortsHeader;
